import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2d5fccc6")

_pushScopeId("data-v-2d5fccc6")
const _hoisted_1 = { class: "info" }
const _hoisted_2 = { class: "first" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_q_space = _resolveComponent("q-space")
  const _component_q_btn = _resolveComponent("q-btn")
  const _component_q_card_section = _resolveComponent("q-card-section")
  const _component_q_card = _resolveComponent("q-card")
  const _component_q_dialog = _resolveComponent("q-dialog")
  const _directive_close_popup = _resolveDirective("close-popup")

  return (_openBlock(), _createBlock(_component_q_dialog, {
    modelValue: _ctx.borrowFeeTipDialogVisible,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.borrowFeeTipDialogVisible = $event))
  }, {
    default: _withId(() => [
      _createVNode(_component_q_card, { class: "borrowFeeTip" }, {
        default: _withId(() => [
          _createVNode(_component_q_card_section, { class: "row items-center borrowFeeTipTitle" }, {
            default: _withId(() => [
              _createVNode("div", null, _toDisplayString(_ctx.t('borrowFeeTipDialog.tip')), 1),
              _createVNode(_component_q_space),
              _withDirectives(_createVNode(_component_q_btn, {
                icon: "close",
                flat: "",
                round: ""
              }, null, 512), [
                [_directive_close_popup]
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, { class: "borrowFeeTipBody" }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_1, [
                _createVNode("div", null, [
                  _createVNode("img", {
                    src: _ctx.larixImg,
                    width: "86.4",
                    height: "86.4",
                    style: {"border-radius":"50%"}
                  }, null, 8, ["src"])
                ]),
                _createVNode("div", _hoisted_2, _toDisplayString(_ctx.t('borrowFeeTipDialog.noBorrowFee')), 1)
              ]),
              _createVNode(_component_q_btn, {
                rounded: "",
                "no-caps": "",
                class: "button",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.gotIt()))
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('borrowFeeTipDialog.gotIt')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
})